import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Users, BookOpen, DollarSign, Sparkles, Award, ListChecks } from "lucide-react";

export default function AdminOverview() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/api/admin/stats").then(({data}) => setStats(data)); }, []);

  const cards = [
    { label: "Students", icon: Users, key: "students", color: "#D92D20" },
    { label: "Courses", icon: BookOpen, key: "courses_total", color: "#064E3B" },
    { label: "Published", icon: ListChecks, key: "courses_published", color: "#D97706" },
    { label: "Enrollments", icon: BookOpen, key: "enrollments", color: "#064E3B" },
    { label: "Revenue (USD)", icon: DollarSign, key: "revenue_usd", color: "#D92D20", prefix: "$" },
    { label: "Completed", icon: Award, key: "completed_enrollments", color: "#D97706" },
    { label: "AI Tutor responses", icon: Sparkles, key: "ai_tutor_responses", color: "#064E3B" },
  ];

  return (
    <div data-testid="admin-overview">
      <div className="label-eyebrow">Overview</div>
      <h1 className="font-display font-black text-3xl mt-1">Admin dashboard</h1>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-8">
        {cards.map((c) => {
          const Icon = c.icon;
          return (
            <div key={c.key} className="bg-white border border-[#E5E7EB] rounded-xl p-5" data-testid={`stat-${c.key}`}>
              <div className="flex items-center justify-between">
                <div className="label-eyebrow">{c.label}</div>
                <Icon className="w-5 h-5" style={{ color: c.color }} />
              </div>
              <div className="font-display font-black text-3xl mt-2">{c.prefix || ""}{stats?.[c.key] ?? "—"}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
